import { Hitbox } from "@ortho-next/three-base";
import { CircleGeometry, Group, Mesh, MeshBasicMaterial, RingGeometry } from "three";
import { Default } from "../../Utils/Default.js";
export class Hexagon extends Group {
    constructor(viewType, color, createHitbox = false) {
        super();
        this.name = "Hexagon";
        const hexagonMaterial = new MeshBasicMaterial({ color: color, transparent: true, depthTest: false });
        const pointMaterial = new MeshBasicMaterial({ color: color, transparent: true, opacity: 0.2, depthTest: false });
        this.add(this._hexagon = new Mesh(Hexagon.hexagonGeometry, hexagonMaterial), this._point = new Mesh(Hexagon.pointGeometry, pointMaterial));
        this._hexagon.interceptedByRaycaster = false;
        this._point.interceptedByRaycaster = false;
        if (createHitbox) {
            this.registerHitbox(new Hitbox(Hexagon.hitboxGeometry));
            this.isDraggable = true;
            Default.bindHitboxScaleByScaleFactorAndZoom(viewType, this);
        }
        else {
            this.interceptedByRaycaster = false;
        }
        Default.scaleByScaleFactorPoints(this);
        this.bindEvent("onHover", () => {
            this.add(Default.donut);
        });
        this.bindEvent("onLeave", () => {
            this.remove(Default.donut);
            this.needsRender = true;
        });
    }
    dispose() {
        super.dispose();
        this._hexagon.material.dispose();
        this._point.material.dispose();
    }
}
Hexagon.hexagonGeometry = new RingGeometry(1.4, 1.7, 6, 1, Math.PI / 2);
Hexagon.pointGeometry = new CircleGeometry(0.7, 15);
Hexagon.hitboxGeometry = new CircleGeometry(1.7, 15);
//# sourceMappingURL=Hexagon.js.map